module.exports = "<h2 class=\"dash-header\" hide-xs>\n  <span>My Crews</span>\n</h2>\n"